<template>
    <section class="services container">
        <div class="wrapper">
            <h2 class="services__header"><span class="underlined-text">What</span> we do</h2>
            <ul class="services-list">
                <li class="service" v-for="(service,index) in services" :key="index">
                    <img :src="service.imageUrl">
                    <h3 class="service__title">{{ service.title }}</h3>
                    <p class="service__description">{{ service.description }}</p>
                </li>
                <div class="services-list__shadow"></div>
            </ul>
        </div>
        <img class="shape-drop-secondary" src="@/assets/img/shape-drop-secondary.svg">
    </section>
</template>

<script>
export default {
  props: ['services']
}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

.services {
  position: relative;
  margin-bottom: 80px;
  padding-bottom: 100px;
  text-align: center;
  @media (min-width: $laptop-s) {
    padding-bottom: 220px;
  }
}
.services__header {
  font-size: 1.25em;
  font-weight: 600;
  letter-spacing: -0.5px;
  margin-bottom: 40px;
  @media (min-width: $laptop-s) {
    font-size: 2em;
  }
  @media (min-width: $laptop-l) {
    font-size: 2.2em;
  }
}
.services-list {
  position: relative;
  background: #fff;
  padding: 0;
  max-width: $phone-l;
  margin: 0 auto;
  @media (min-width: $tablet) {
    max-width: none;
    display: flex;
    flex-wrap: wrap;
  }
}
.service {
  padding: 1em;
  &:not(:last-of-type) {
    margin-bottom: 40px;
  }
  @media (min-width: $tablet) and (max-width: 1023px) {
    padding: 2em;
    width: 50%;
    margin-bottom: 0 !important;
    &:nth-of-type(2n-1) {
      border-right: 1px solid #ececec;
    }
    &:not(:nth-last-of-type(-n + 2)) {
      border-bottom: 1px solid #ececec;
    }
  }
  @media (min-width: $laptop-s) {
    width: calc(100% / 3);
    margin-bottom: 0 !important;
    width: calc(100%/3);
    &:not(:nth-of-type(3n)) {
      border-right: 1px solid #ececec;
    }
    &:not(:nth-last-of-type(-n + 3)) {
      border-bottom: 1px solid #ececec;
    }
  }
}
.service__title {
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 500;
}
.service__description {
  font-size: 0.93em;
}
.services-list__shadow {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  width: 100%;
  height: 100%;
  -webkit-filter: blur(27.8px);
  filter: blur(27.8px);
  background-color: rgba(39, 46, 57, 0.16);
}
.shape-drop-secondary {
  width: 45%;
  z-index: -2;
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 560px;
}
</style>
